"use strict";

define('legacy.router',['underscore', 'backbone', 'backbone.radio', 'appkit/router'], function (_, Backbone, Radio, Router) {
  var LegacyRouter = Router.extend({
    route: function route(_route, name, callback) {
      var strRoute = _route;
      if (!_.isRegExp(_route)) _route = this._routeToRegExp(_route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (name) {
        this._registerName(name, strRoute);
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(_route, function (fragment) {
        var legacyApp = Radio.channel('singleton').request('legacyApp');
        Promise.resolve(legacyApp.canLeaveContentController()).tap(function () {
          legacyApp.clearCurrentRoute();
          return legacyApp.destroyContentController();
        }).tap(function () {
          legacyApp.setContentController(null);
          router.executeRouting(_route, name, callback, fragment);
        })["catch"](function (err) {
          if (err && err.name == 'NavigationCancelled') {
            Backbone.history.navigate(legacyApp.getCurrentRoute(), {
              replace: false
            });
          } else {
            throw err;
          }
        });
      });
      return this;
    },
    executeRouting: function executeRouting(route, name, callback, fragment) {
      var router = this,
        args = router._extractParameters(route, fragment),
        ev = {
          preventDefault: false,
          fragment: fragment,
          execute: executeRoute
        },
        didRoute = false,
        params = router._resolveParams(name, args);
      function executeRoute() {
        if (didRoute) {
          return;
        }
        didRoute = true;
        router.trigger.apply(router, ['route:' + name, params]);
        router.trigger('route', name, params);
        Backbone.history.trigger('route', router, name, params);
      }
      router.trigger.apply(router, ['before:route:' + name, ev, params]);
      router.trigger('before:route', name, ev, params);
      Backbone.history.trigger('before:route', router, name, ev, params);
      if (ev.preventDefault !== true && router.execute(callback, params, name) !== false) {
        executeRoute();
      }
    }
  });
  return LegacyRouter;
});

